import { ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { Dialog } from 'vant'
import { getStudyQuesList, getQuesList } from '@/api/index'
import { getQueryString } from '@/utils/tools'

// 获取学习题（分页）
export const useCommonStudyListEffect = () => {
  const listQuery = reactive({
    offSet: 1,
    pageSize: 10,
  })

  const partLoading = ref(false)
  const store = useStore()

  const questionActiveKey = getQueryString('questionActiveKey')
  const isPreview = 3

  const getStudyList = async (index) => {
    partLoading.value = true
    listQuery.offSet = Math.ceil(index / listQuery.pageSize)
    const list = store.getters.getStudyQuesList
    const result = await getStudyQuesList({
      questionActiveKey,
      isPreview,
      ...listQuery,
    })
    if (result.ok) {
      list.length = result.data.total
      const startIndex =
        listQuery.offSet * listQuery.pageSize - listQuery.pageSize
      list.splice(startIndex, 0, ...result.data.rows)
      store.commit('initStudyQuesList', {
        list: list,
      })
      list.length = result.data.total
    }
    partLoading.value = false
  }

  return {
    listQuery,
    partLoading,
    getStudyList,
  }
}

// 获取考试题目
export const useCommonQuesListEffect = () => {
  const store = useStore()
  const loading = ref(true)
  const questionActiveKey = getQueryString('questionActiveKey')
  const isPreview = Number(getQueryString('isPreview'))
  const showRefresh = ref(false)

  const getQuesData = async (list, quesData) => {
    try {
      const result = await getQuesList({
        questionActiveKey,
        // questionActiveKey: 'f5c9d0857c9742fba07c7febd5d6211f',
        isPreview,
        type: store.getters.getQuesInfo.type === 3 ? 3 : 1,
      })
      if (result?.ok && result?.data) {
        if (list !== undefined) {
          list.value = result.data

          const localAnswers = localStorage.getItem('localAnswers')

          if (localAnswers) {
            const tmp = JSON.parse(localAnswers)

            list.value.map((item) => {
              tmp.map((local) => {
                if (item.questionKey === local.questionKey) {
                  if (
                    item.title.indexOf('上报人姓名') !== -1 ||
                    item.title.indexOf('上报人手机号') !== -1
                  ) {
                    item.value = local.answers[0].answerContent
                  }

                  if (
                    item.questionType === 2 &&
                    item.title.indexOf('上报单位') !== -1
                  ) {
                    item.localChecked = local.answers.answerContent
                    item.localOptionKey = local.answers.optionKey
                  }
                }
              })
            })
          }
        }
        if (quesData !== undefined) {
          quesData.value = result.data[0]
        }
        store.commit('initQuesList', {
          list: result.data,
        })
        // 初始化answers长度
        store.commit('initAnswers', {
          length: list.value.length,
        })
        loading.value = false
      } else {
        // 下线状态
        if (result.comment.indexOf('问卷已下线') !== -1) {
          Dialog({ message: '问卷已下线' })
          return null
        }
        Dialog({ message: result.comment })
      }
      loading.value = false
    } catch (e) {
      showRefresh.value = true
      loading.value = false
    }
  }

  return {
    getQuesData,
    loading,
  }
}
